import { useEffect } from "react";
import store from "../store";
import useHttp from "../hooks/useHttp";
import { USER_DETAILS_URL } from "../utils/api-ends";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { fetchBasicInfo } from "../store/slices/basicInfo";


function BasicSetup() {
  
  const isAuthenticated = useSelector(
    (state) => state.basicInfo?.isAuthenticated
  );
  const { sendRequests } = useHttp();
  const navigate = useNavigate();
  

  useEffect(() => {
    const response = (data) => {
      store.dispatch(
        fetchBasicInfo({
          isAuthenticated: true,
          userInfo: data?.data.user_info,
          latestChatRooms: data?.data.chat_rooms_info,
        })
      );

      // Not verified user redirect to verification page
      if(data?.data?.user_info?.is_account_verified === false){
        if (data.data.user_info.have_to_verify === "both") {
          navigate("/auth/account-verification?to_verify=both");
        } else if (data.data.user_info.have_to_verify === "email") {
          navigate("/auth/account-verification?to_verify=email");
        } else if (data.data.user_info.have_to_verify === "phone") {
          navigate("/auth/account-verification?to_verify=phone");
        }
      }
    };
    sendRequests(
      {
        url: USER_DETAILS_URL,
        method: "GET",
      },
      response
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
}

export default BasicSetup;
